export interface PlanYearDto {
  id?: number;
  name?: string;
  valid_from?: string;
  valid_to?: string | null;
}

export interface SpendPeriodDto {
  spend_period_type: string;
  period_start: string;
  period_end: string | null;
  plan_years: PlanYearDto[];
}

export interface SpendPeriodRemainingDto {
  remaining: number | null;
  spend_limit: number | null;
}

export enum PeriodText {
  PLAN_YEAR = 'per plan year',
  MONTHLY = 'monthly',
  DEFAULT = ''
}
